module.exports = __webpack_public_path__ + "static/media/gun.cba34841.svg";